import React, { Component } from "react";
import { Form, Input, Select } from "antd";
import { connect } from "react-redux";

import style from "./list.module.sass";
import {
    addFroms,
    updateForms
} from "../../../../stateManager/store/forms/action";
import { setGuideVisible, setStepIndex } from "../../../../stateManager/store/onboarding/action"
import { Http } from "../../../../helpers/axois";
import { pushToast } from '../../../../stateManager/store/toast/actions'
import publicIcon from "../../../../assets/svg/solo/public_col_ico.svg"
import { updateOnboarding } from "../../../../helpers/onboardingHelper";
const { Option } = Select;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
    }
};

interface State {
    formName?: string;
    description?: string;
    soloName?: string;
    displayName?: string;
    selectedFlow?: any;
    selectedJourney?: any;
    // isJourneyTypeEdit: boolean;
    selectType?: any;
    selectedAuth: any;
    soloDetails?: any;
    displayErr?: any;
    flowNameFieldDisplayErr?: any;
    displayNameFieldError? : any;
    selectedFlowDisplayErr?: any;
    editDisplayErr?: any;
    disabledSelection?: any;
}

interface Props {
    onSubmit: (submit: () => void) => void;
    appId?: any;
    getSolo: () => void;
    getSoloFlows?: any;
    soloModal?: boolean;
    addFroms?: (data: any) => void;
    editInitialData?: any;
    editable?: boolean;
    updateForms: (data: any) => void;
    pushToast: (data: any) => void;
    currentBranch?: any;
    appVersion?: { currentVersion: boolean, versionId: string };
    editSoloData?: any;
    editType?: string;
    setvisible: any;
    okButtonText: string;
    cancelText: string;
    onCancel: () => void;
    setStepIndex: (data: any) => void;
    setGuideVisible: (data: any) => void;
    stepIndex: number;
    onboardingInfo: any;
    userName: string;
    guideVisible: any
}
class Solo extends Component<Props, State> {
    constructor(props: any) {
        super(props);
        this.state = {
            soloName:
                this.props.editSoloData && this.props.editSoloData.name
                    ? this.props.editSoloData.name
                    : "",
            displayName: this.props.editSoloData && this.props.editSoloData.displayName
                    ? this.props.editSoloData.displayName
                    : "",
            flowNameFieldDisplayErr: "",
            displayNameFieldError: "",
            selectedAuth: "",
            selectType: this.props.editSoloData && (this.props.editSoloData.type || " "),
        };
    }
    componentDidMount() {
        this.getSolo()
    }
    onSubmit = () => {
        let { editable, editSoloData } = this.props;
        if ((editable) || (editable && this.state.formName)) {
            this.soloEditFrom(editSoloData.id)
        } else if (editable) {
            this.setState({ editDisplayErr: "required" })
        }
        if ((!editable && this.state.soloName && (this.state.selectedFlow))) {
            this.createForm();
        } else if (!editable && !this.state.soloName && !this.state.selectedFlow && !this.state.displayName) {
            this.setState({ flowNameFieldDisplayErr: "required" })
            this.setState({ selectedFlowDisplayErr: "required" })
        } else if (!editable && !this.state.soloName) {
            this.setState({ flowNameFieldDisplayErr: "required" })
        }else if (!editable && !this.state.displayName) {
            this.setState({ displayNameFieldError: "required" })
        }else if (!editable && !(this.state.selectedFlow)) {
            this.setState({ selectedFlowDisplayErr: "required" })
        } else if (!editable) {
            this.setState({ displayErr: "required" })
        }
    };

    createForm() {
        const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.appId] && this.props.currentBranch[this.props.appId].branchId
        const soloData = {
            name: this.state.soloName,
            displayName: this.state.displayName,
            type: this.state.selectedFlow,
            versionId: this.props.appVersion && this.props.appVersion.versionId,
            branchId: currentBranchId
        }
        const stepIndex = this.props.stepIndex;
        if (this.props.guideVisible) {
            this.props.setStepIndex(stepIndex + 1)
        }
        Http.post(`apps/${this.props.appId}/solo-flows`, soloData).subscribe((formRes: any) => {
            this.props.pushToast(
                { type: 'success', message: 'solo saved successfully' }
            )
            this.props.getSolo();
            this.props.getSoloFlows && this.props.getSoloFlows(formRes);
            this.props.setvisible(false)
            if (this.props.guideVisible) {
                const payload = {
                    ...this.props.onboardingInfo,
                    stepIndex: stepIndex + 1,
                    flowId: formRes.id
                }
                updateOnboarding(this.props.userName, payload) 
            }
        }, (err) => {
            this.props.pushToast(
                { type: 'error', message: ((err && err.message) || (err && err.error)) ? err.message ? err.meassage : err.error : 'solo save failed' }
            )
            this.props.setvisible(false)
        })
    }


    soloEditFrom(id: string) {
        const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.appId] && this.props.currentBranch[this.props.appId].branchId
        const data: any = {
            name: this.state.soloName || (this.props.editSoloData && this.props.editSoloData.name),
            displayName: this.state.displayName || (this.props.editSoloData && this.props.editSoloData.displayName),
            type: (this.state.selectedFlow || (this.props.editSoloData && this.props.editSoloData.type)),
            versionId: this.props.appVersion && this.props.appVersion.versionId,
            branchId: currentBranchId,
        }
        if (this.state.selectedAuth) {
            data.authFlow = this.state.selectedAuth
        }
        Http.put(`apps/${this.props.appId}/solo-flows/${id}`, data).subscribe((res) => {
            this.props.pushToast(
                { type: 'success', message: 'solo updated successfully' }
            )
            this.props.getSolo();
            this.props.setvisible(false)
        }, (err) => {
            this.props.pushToast(
                { type: 'error', message: (err && err.message) ? err.message : 'solo updation failed' }
            )
            this.props.setvisible(false)
        })
    }

    getSolo() {
        const versionId = this.props.appVersion && this.props.appVersion.versionId;
        if (versionId) {
            Http.get(`/apps/${this.props.appId}/solo-flows?versionId=${versionId}`).subscribe((formRes: any) => {
                this.setState({
                    soloDetails: formRes.flows
                })
            }, (err: any) => {
            });
        }
    }


    render() {
        let { editSoloData } = this.props;
        let publicSoloDetails = this.state.soloDetails && this.state.soloDetails.filter((el: any) => {
            return this.props.editSoloData && this.props.editSoloData.id !== el.id && el.type === "public"
        })
        const editAuthType = (this.state.selectedFlow === "private" ? true : this.state.selectedFlow === "public" ? false : this.props.editSoloData && this.props.editSoloData.type === "private")
        return (
            <div>
                {<Form {...formItemLayout} className={style.app + ' override-content'}>
                    <Form.Item
                        className="tour_create_journey_name_step"
                        validateStatus={(this.state.displayNameFieldError && "error") || (this.state.editDisplayErr && "error")}
                        help={this.state.displayNameFieldError || this.state.editDisplayErr}
                        label={<span className={style.labelName}>Display Name</span>}>
                        <Input
                            className="tour_input__focus"
                            data-test-id="display_Name"
                            defaultValue={editSoloData && editSoloData.displayName} 
                            value={this.state.displayName}
                            onChange={(e: any) =>{
                                const re = /^[A-Za-z_][A-Za-z0-9,_/;'"!&@%$-\s]*$/;                            ;
                                if (e.target.value === '' || re.test(e.target.value)) {
                                    let val =  e.target.value.replace(/[^a-zA-Z0-9_ ]/g, "") 
                                    let value =  val.replace(/ /g,"_") 
                                    this.setState({ soloName: !editSoloData ? 
                                        value  : editSoloData.name, displayName: e.target.value , displayNameFieldError: "" })
                                }
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        validateStatus={(this.state.flowNameFieldDisplayErr && "error") || (this.state.editDisplayErr && "error")}
                        help={this.state.flowNameFieldDisplayErr || this.state.editDisplayErr}
                        label={<span className={style.labelName}>Name(Identifier)</span>}>
                        <Input
                            disabled={editSoloData?.name}
                            data-test-id="solo_name"
                            defaultValue={editSoloData && editSoloData.name}
                            value={this.state.soloName}
                            onChange={(e: any) => {
                                const re = /^[A-Za-z_][A-Za-z0-9_]*$/;
                                if (e.target.value === '' || re.test(e.target.value)) {
                                    this.setState({ soloName: e.target.value, flowNameFieldDisplayErr: "" })
                                }
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        className="tour_journey_desc"
                        label={<span className={style.labelName}>Flow Type</span>}
                        validateStatus={this.state.selectedFlowDisplayErr && "error"}
                        help={this.state.selectedFlowDisplayErr}
                    >
                        <Select dropdownStyle={{zIndex: 99999}} data-test-id="flow" defaultValue={this.state.selectType} style={{ width: "100%" }} onChange={(e: any) => this.setState({ selectedFlow: e, selectedFlowDisplayErr: "" })}>
                            <Option key="private" value="private">Private</Option>
                            <Option key="public" value="public">Public</Option>
                        </Select>
                    </Form.Item>
                    {this.props.editSoloData && editAuthType && <Form.Item label={<span className={style.labelName}>Auth Flow</span>}>
                        <Select data-test-id="flow" value={this.state.selectedAuth || editSoloData && editSoloData?.authFlow} style={{ width: "100%" }} onChange={(e: any) => this.setState({ selectedAuth: e })}>
                            {publicSoloDetails && publicSoloDetails.map((solo: any) => {
                                return (
                                    <Option key={solo.id} value={solo.name}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {solo.type === "public" && <img alt="publicIcon" style={{ height: "15px" }} src={publicIcon} />}
                                            {solo.type === "public" && <div style={{ fontSize: "15px", marginLeft: "4px", marginTop: "2px" }}>{solo.name}</div>}
                                        </div>
                                    </Option>
                                )
                            })}
                        </Select>
                    </Form.Item>}
                </Form>}
                <div className={style.cre_journey_footer}>
                    <button className={style.cancel} onClick={()=>{this.props.onCancel()}} >{this.props.cancelText}</button>
                    <button className={`${style.create} tour_journey_creation`} onClick={()=>{this.props.onSubmit(this.onSubmit)}}>{this.props.okButtonText}</button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        currentBranch: state.apps.appBranch,
        selectedJourney: state.solo.selectedJourneyInBpmn,
        stepIndex: state.onboarding.info.stepIndex,
        onboardingInfo: state.onboarding.info,
        guideVisible: state.onboarding.guideVisible,
        userName: state.user.data.user.userName
    }
}

export default connect(
    mapStateToProps,
    { addFroms, updateForms, pushToast, setGuideVisible, setStepIndex  }
)(Solo);
